export default {
  setPermissions (state, permissions) {
    state.permissions = permissions
  },
}
